import type { ClientRequirePORequest } from '@contracts/client/ClientRequirePORequest';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  clientId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useUpdateRequirePO = ({ clientId, onSuccess, onError }: Props) => {
  const { mutate, isPending, isError } = useMutation({
    mutationFn: (data: ClientRequirePORequest) => {
      return ClientsClient.updateRequirePO(clientId, data);
    },
    onSuccess,
    onError,
  });

  return {
    updateRequirePO: mutate,
    isLoading: isPending,
    isError,
  };
};
